module.exports = __webpack_public_path__ + "media/packs/images/cargo-fetching-726fc725d3f07a6554e754e910b43935.svg";